import { useCallback, useEffect, useRef, useState } from 'react';

import { isBrowser } from '@/utils';

const useDynamicHeightChange = () => {
  const [height, setHeight] = useState(0);
  const [isHeightChanged, setIsHeightChanged] = useState(false);
  const minimumViewportHeight = useRef(
    isBrowser() ? Math.round(window.innerHeight) : 0
  );

  const handleResize = useCallback(
    function (this: VisualViewport, _event: Event) {
      const newHeight = window.innerHeight;
      const isHeightExpanded =
        Math.round(newHeight) > minimumViewportHeight.current;

      setHeight(newHeight);
      if (isHeightExpanded) {
        setIsHeightChanged(true);
      } else {
        setIsHeightChanged(false);
      }
    },
    [height]
  );

  useEffect(() => {
    // The minimum viewport height will be the initial height or the smallest height observed
    if (!isBrowser()) return;
    minimumViewportHeight.current =
      height === 0
        ? window.innerHeight
        : Math.round(
            Math.min(height, minimumViewportHeight.current, window.innerHeight)
          );
  }, [height]);

  useEffect(() => {
    if (!isBrowser()) return;
    const viewport = window.visualViewport;
    if (!viewport) return;
    viewport.addEventListener('resize', handleResize);
  }, []);

  return {
    isHeightChanged,
    height,
  };
};

export default useDynamicHeightChange;
